<template>
  <div>
    <top-nav title='' noshadow></top-nav>
    <div class="second_wrap" :style="{height: height-46 + 'px'}">
      <van-sidebar v-model="activeKey" class="slide" @change="getSecond">
        <van-sidebar-item v-for="(item,i) in yjType" :key="i" :title="item.name"  :class="{'main_bg white_f': activeKey===i}"/>
      </van-sidebar>
      <div class="content white">
        <ul class="flex">
          <li v-for="(item, i) in secondList" :key="i" @click="tolist(item)">
            <div class="imgbox">
              <img :src="item.icon" alt="">
            </div>
            <p>{{item.name}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { findAmoyEjCategory, findAmoyCategory } from '../../api/home'
export default {
  name: 'secondTab',
  props: {
    // yjType: Array
  },
  data () {
    return {
      activeKey: 0,
      width: 0,
      height: 0,
      yjType: [],
      secondList: []
    }
  },
  created () {
    this.height = document.getElementById('app').clientHeight
    this.findAmoyCategory()
  },
  watch: {
    activeKey (i) {
      // this.yjType[i]
    }
  },
  methods: {
    // 获取淘客一二级分类
    findAmoyCategory () {
      findAmoyCategory({}).then(res => {
        if (res.result === '0') {
          this.yjType = res.dataList
          this.getSecond(0)
        }
      })
    },
    getSecond (i) {
      let data = {
        categoryId: this.yjType[i].id
      }
      findAmoyEjCategory(data).then(res => {
        if (res.result === '0') {
          this.secondList = res.dataList
        }
      })
    },
    tolist (item) {
      let temp = new Date().getTime()
      this.$router.push({path: '/List', query: {title: item.name, 'temp': temp, type: 'ztk', id: item.id}})
    }
  }
}
</script>

<style scoped>
  .second_wrap{
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
  }
  .second_wrap .slide{
    background: #fafafa;
    width: 3rem;
    overflow: auto;
  }
  .content{
    width: 100%;
    padding: .3rem;
    overflow: auto;
  }
  .content ul{
    flex-wrap: wrap;
  }
  .content li{
    margin: 5% 2%;
    width: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .content .imgbox{
    width: 1.2rem;
    height: 1.2rem;
    /*background: red;*/
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/view/home/secondTab.vue